import { useState } from 'react';

interface UseSearchStateReturn {
  showSearchDialog: boolean;

  openSearchDialog: () => void;
  closeSearchDialog: () => void;
}

const useSearchState = (clearSelection?: () => void): UseSearchStateReturn => {
  const [showSearchDialog, setShowSearchDialog] = useState(false);

  const openSearchDialog = () => {
    if (clearSelection) clearSelection();
    setShowSearchDialog(true);
  };
  const closeSearchDialog = () => setShowSearchDialog(false);

  return {
    showSearchDialog,

    openSearchDialog,
    closeSearchDialog
  };
};

export default useSearchState;
